import React, { memo, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { InputSelect, InputText } from "../../../components";
import InputImport from "../../../components/input/import";
import {
  Button,
  CreateAlert,
  InputWraper,
  onError,
  useForm
} from "../../../modules";
import { AppService } from "../../../services/app";
import { validationSchema } from "../YupSchema";


const Form = ({ id }: { id: string | undefined }) => {
  const history = useHistory();

  const handleCancel = () => history.goBack();

  const { handleSubmit, getInputProps, isSubmitting, setValues } = useForm({
    structure: validationSchema,
    onSubmit: async (values: any) => {
      const { installFileSize } = values

      const payload = {
        ...values,
        installFileSize: (+installFileSize)?.toFixed(0)
      }

      if (id) {
        return AppService.edit(id, payload)
          .then(() => {
            CreateAlert({
              type: "success",
              message: "Cập nhật App thành công!",
            });
            handleCancel();
          })
          .catch(onError);
      }

      AppService.create(payload)
        .then(() => {
          CreateAlert({ type: "success", message: "Tạo App thành công!" });
          handleCancel();
        })
        .catch(onError);
    },
  });
  

  useEffect(() => {
    if (!id) return;

    AppService.getDetail(id).then((res) => {
      const { name, version, isActive, installFileUrl, installFileSize, imageUrl, appId, packageName } = res

      setValues({
        name,
        version,
        isActive,
        installFileUrl,
        installFileSize,
        imageUrl,
        appId,
        packageName
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="content">
      <form autoComplete="off" onSubmit={handleSubmit}>
        <div className="firmwares-modifi">
          <div className="firmwares-modifi-form">
            <InputWraper
              isRequired
              label={"Tên app"}
              inputProps={getInputProps("name")}
              component={InputText}
            />
            
            <InputWraper
              isRequired
              label={"Package name"}
              inputProps={getInputProps("packageName")}
              component={InputText}
            />

            <InputWraper
              isRequired
              label={"Version"}
              inputProps={getInputProps("version")}
              component={InputText}
            />
            
            <InputWraper
              isRequired
              label={"File App"}
              inputProps={getInputProps("installFileUrl")}
              component={(props) => {
                return <InputImport {...props} onChange={(val) => {
                  setValues({ installFileUrl: val?.url, installFileSize: +(val?.file?.size / 1024)?.toFixed(0) })
                }}/>
              }}
            />

            <InputWraper
              isRequired
              label={"Kích thước App"}
              inputProps={getInputProps("installFileSize")}
              component={InputText}
            />

            <InputWraper
              isRequired
              label={"Ảnh đại diện"}
              inputProps={getInputProps("imageUrl")}
              component={(props) => {
                return <InputImport {...props} onChange={(val) => {
                  setValues({ imageUrl: val?.url })
                }}/>
              }}
            />

            <InputWraper
              isRequired
              label={"Trạng thái"}
              inputProps={getInputProps("isActive")}
              component={(e) => (
                <InputSelect
                  {...e}
                  options={AppService.getAppStatus()}
                />
              )}
            />
          </div>
        </div>
      </form>

      <div className="btn-submit">
        <Button onClick={handleCancel} label="Hủy" isLoading={isSubmitting} />
        <Button
          buttonType="success"
          onClick={handleSubmit}
          label="Lưu"
          type="submit"
          isLoading={isSubmitting}
        />
      </div>
    </div>
  );
};

export default memo(Form);
